/* カートの一言と支払い方法の1行（2026-10-09 神城。オーナー10/8・10/9 許可）
   ① 2BUY1FREEの対象がカートにちょうど1点の時だけ、カートの引き出しとカートのページに
      「あと1点で、3点目タダ。」を出す。何点あるかの判定はサーバー側（snippets/eh-cart-nudge.liquid）。
      このファイルは「置く場所」と「カートが変わった後の取り直し（/cart?sections=eh-cart-nudge）」だけ。
   ② 商品ページの購入ボタンの下と、カートの決済ボタンの近く（引き出しはボタンの真上・カートのページはボタンの下）に
      「全国送料無料｜PayPay・コンビニ・あと払い・Apple Pay」（10/9 チェックアウトで有効を確認した物だけ）。
   ③ iPhone・iPadのインスタのアプリの中で開いた時だけ「Safariで開くとApple Payが使えます」。
   戻す＝layout/theme.liquid の </body> 直前の3行を消す（このファイルは読まれなくなる）。
   割引・価格・商品・コレクションには一切触らない（表示だけ）。 */
(function () {
  'use strict';
  if (window.__ehCartPay) return;
  window.__ehCartPay = true;

  var SECTION = 'eh-cart-nudge';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var ua = navigator.userAgent || '';
  var IG_IOS = /Instagram/i.test(ua) && /iPhone|iPad|iPod/i.test(ua);

  var CSS = [
    '.eh-nudge{display:block;margin:0 0 12px;padding:12px 14px 11px;border-radius:12px;text-align:center;color:#fff;',
    'background:linear-gradient(135deg,#22403f 0%,#385C60 55%,#4a848a 100%);box-shadow:0 10px 22px -14px rgba(22,41,43,.85),inset 0 0 0 1px rgba(233,201,135,.22);line-height:1.35;}',
    '.eh-nudge__big{display:block;font-size:19px;font-weight:900;letter-spacing:.02em;color:#fff;}',
    '.eh-nudge__big b{font-weight:900;color:#f4d896;}',
    '.eh-nudge__small{display:block;margin-top:4px;font-size:11.5px;font-weight:600;color:rgba(232,242,242,.92);}',
    '.eh-nudge a.eh-nudge__more{display:inline-block;margin-top:5px;font-size:11px;font-weight:700;color:#f4d896;text-decoration:underline;text-underline-offset:2px;}',
    '.ajaxcart__inner .eh-nudge{margin:0 0 18px;}',
    '.page-cart .eh-nudge{max-width:420px;margin:0 0 14px auto;}',
    '.eh-pay{margin:10px 0 0;text-align:center;}',
    '.eh-pay__line{margin:0;font-size:12px;font-weight:700;line-height:1.55;letter-spacing:.01em;color:#385C60;}',
    '.eh-pay__line span{display:inline-block;}',
    '.eh-pay__ig{margin:3px 0 0;font-size:11px;line-height:1.45;color:#5f7173;}',
    '.ajaxcart__footer .eh-pay{margin:-6px 0 4px;}',
    '.page-cart .eh-pay{text-align:right;}',
    '@media(max-width:767px){.page-cart .eh-nudge{max-width:none;margin:0 0 14px;}.page-cart .eh-pay{text-align:center;}}'
  ].join('');

  // 2026-10-15 国旗の切り替え（assets/eh-locale.js）に合わせて：日本以外の国を選んだ人には出さない
  // （ドル等の決済画面では PayPay・コンビニ・あと払いは出ない＝10/15 実物で確認）。日本×英語は英語で出す。
  var SH = window.Shopify || {};
  var IN_JP = !SH.country || SH.country === 'JP';
  var JA = !SH.locale || SH.locale === 'ja';
  var PAY_HTML = !IN_JP ? '' : JA
    ? '<p class="eh-pay__line"><span>全国送料無料</span>｜<span>PayPay・コンビニ・あと払い・Apple Pay</span></p>' +
      (IG_IOS ? '<p class="eh-pay__ig">Safariで開くとApple Payが使えます</p>' : '')
    : '<p class="eh-pay__line"><span>Free shipping across Japan</span>｜<span>PayPay · Convenience store · Pay later (Paidy) · Apple Pay</span></p>' +
      (IG_IOS ? '<p class="eh-pay__ig">Open in Safari to use Apple Pay</p>' : '');

  var nudgeHTML = '';

  function extract(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var s = d.querySelector('.eh-nudge-src');
    return s ? s.innerHTML.replace(/^\s+|\s+$/g, '') : '';
  }

  function readInit() {
    var t = document.getElementById('eh-cart-nudge-init');
    return t ? extract(t.innerHTML) : '';
  }

  function payNode(where) {
    var w = document.createElement('div');
    w.className = 'eh-pay eh-pay--' + where;
    w.setAttribute('data-eh-pay', where);
    w.innerHTML = PAY_HTML;
    return w;
  }

  function slotNode(where) {
    var w = document.createElement('div');
    w.className = 'eh-nudge-slot eh-nudge-slot--' + where;
    w.setAttribute('data-eh-nudge', where);
    w.innerHTML = nudgeHTML;
    return w;
  }

  function isOurs(el, attr) {
    return !!(el && el.getAttribute && el.getAttribute(attr) !== null);
  }

  // テーマはカートの引き出しの下の欄（小計・お会計）の高さを測って固定する。支払い方法の1行を足した分を測り直させる
  function refit() {
    var $ = window.jQuery;
    if ($ && document.querySelector('[data-cart-container] .ajaxcart__footer')) {
      try { $(document.body).trigger('drawer.footer'); } catch (e) {}
    }
  }

  function ensure() {
    var i, f, list, btns, drawer = false;
    // 商品ページ：購入ボタンのまとまりの直後
    list = document.querySelectorAll('.product-single__buttons');
    for (i = 0; i < list.length; i++) {
      if (PAY_HTML && !isOurs(list[i].nextElementSibling, 'data-eh-pay')) list[i].insertAdjacentElement('afterend', payNode('product'));
    }
    // カートの引き出し：一言は商品の並びの一番上（下の欄はチャットの丸ボタンと重なるため）、決済ボタンの真上に支払い方法
    list = document.querySelectorAll('[data-cart-container] .ajaxcart__inner');
    for (i = 0; i < list.length; i++) {
      if (!isOurs(list[i].firstElementChild, 'data-eh-nudge')) list[i].insertBefore(slotNode('drawer'), list[i].firstChild);
    }
    list = document.querySelectorAll('[data-cart-container] .ajaxcart__footer');
    for (i = 0; i < list.length; i++) {
      f = list[i];
      btns = f.querySelector('.ajaxcart__footer-buttons');
      // ボタンの真上に置く（ボタンの位置は今までと同じ。下に置くとボタンが上がってチャットの丸ボタンと重なる）
      if (PAY_HTML && btns && !isOurs(btns.previousElementSibling, 'data-eh-pay')) { btns.insertAdjacentElement('beforebegin', payNode('drawer')); drawer = true; }
    }
    // カートのページ：小計の上に一言、決済ボタンの下に支払い方法
    list = document.querySelectorAll('#cart-form .cart-total');
    for (i = 0; i < list.length; i++) {
      f = list[i];
      if (!f.querySelector('[data-eh-nudge]')) f.insertBefore(slotNode('page'), f.firstChild);
      btns = f.querySelector('.cart-total__buttons');
      if (PAY_HTML && btns && !isOurs(btns.nextElementSibling, 'data-eh-pay')) btns.insertAdjacentElement('afterend', payNode('page'));
    }
    if (drawer) refit();
  }

  function setNudge(html) {
    if (html === nudgeHTML) return;
    nudgeHTML = html;
    var s = document.querySelectorAll('[data-eh-nudge]');
    for (var i = 0; i < s.length; i++) s[i].innerHTML = nudgeHTML;
  }

  var timer = null, seq = 0;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var my = ++seq;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'cart?sections=' + SECTION;
      var done = function (j) {
        if (my !== seq || !j || typeof j[SECTION] !== 'string') return;
        setNudge(extract(j[SECTION]));
      };
      if (window.fetch) {
        window.fetch(url, { credentials: 'same-origin' }) // Accept: application/json を付けると /cart はカートのJSONを返してしまう（10/9 実測）
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(done)['catch'](function () {});
      } else {
        var x = new XMLHttpRequest();
        x.open('GET', url);
        x.onload = function () { try { done(JSON.parse(x.responseText)); } catch (e) {} };
        x.send();
      }
    }, 250);
  }

  // カートを変える通信（テーマは jQuery、ほかは fetch のことがある）が終わったら取り直す
  function watchCartRequests() {
    var $ = window.jQuery;
    if ($ && $.fn && $(document).ajaxComplete) {
      $(document).ajaxComplete(function (e, xhr, settings) {
        if (settings && CART_RE.test(String(settings.url || ''))) refresh();
      });
    }
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (l) {
          var es = l.getEntries();
          for (var i = 0; i < es.length; i++) {
            if ((es[i].initiatorType === 'fetch' || es[i].initiatorType === 'xmlhttprequest') && CART_RE.test(es[i].name)) { refresh(); return; }
          }
        }).observe({ type: 'resource' });
      } catch (e) {}
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; ensure(); }, 30);
  }

  function run() {
    var st = document.createElement('style');
    st.id = 'eh-cart-pay-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
    nudgeHTML = readInit();
    ensure();
    watchCartRequests();
    // カートの引き出しは中身を作り直すたびに消えるので、作り直しを見て置き直す
    if (window.MutationObserver) {
      var mo = new MutationObserver(queue);
      var cs = document.querySelectorAll('[data-cart-container], #cart-form');
      for (var i = 0; i < cs.length; i++) mo.observe(cs[i], { childList: true, subtree: true });
    }
    setTimeout(ensure, 800);
    setTimeout(ensure, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
